import React from 'react';
import styles from './YoutubeVideo.module.scss';

const YoutubeVideo = (props) => {

    return (
        <div className={styles.outerContainer}>
            <div className={styles.container}>
                {props.embedId ?
                    <iframe
                        className={styles.responsive}
                        src={`https://www.youtube.com/embed/${props.embedId}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                    />
                    :
                    <div>embedId not provided</div>
                }
            </div>
        </div>

    );
}

YoutubeVideo.defaultProps = {
    embedId: null,
}

export default YoutubeVideo;
